/**
 * Enable retailer launch announcements for Insider Partnership. * https:www.figma.com/design/JgZOyIXSInH1eIHBst0ThJ/Insider-Partnership-M2%2FM3?node-id=9641-86890&t=74OCLd9lepsf7Tb8-0
 */
export const INSIDER_PARTNERSHIP_LAUNCH_ANNOUNCEMENTS_ENABLED_240715 = 'INSIDER_PARTNERSHIP_LAUNCH_ANNOUNCEMENTS_ENABLED_240715';
